import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const formatIndianCurrency = (value) => {
    const num = value.replace(/,/g, ''); // Remove commas
    if (!/^\d+$/.test(num)) return value; // Only format if valid number
    return Number(num).toLocaleString('en-IN');
};

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const inWords = (n) => {
        if ((n = n.toString()).length > 9) return 'Overflow';
        const nNum = ('000000000' + n).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!nNum) return;
        let str = '';
        str += nNum[1] !== '00' ? (a[Number(nNum[1])] || b[nNum[1][0]] + ' ' + a[nNum[1][1]]) + ' Crore ' : '';
        str += nNum[2] !== '00' ? (a[Number(nNum[2])] || b[nNum[2][0]] + ' ' + a[nNum[2][1]]) + ' Lakh ' : '';
        str += nNum[3] !== '00' ? (a[Number(nNum[3])] || b[nNum[3][0]] + ' ' + a[nNum[3][1]]) + ' Thousand ' : '';
        str += nNum[4] !== '0' ? a[Number(nNum[4])] + ' Hundred ' : '';
        str += nNum[5] !== '00' ? ((str !== '') ? 'and ' : '') + (a[Number(nNum[5])] || b[nNum[5][0]] + ' ' + a[nNum[5][1]]) + ' ' : '';
        return str.trim() + ' Rupees Only';
    };

    return inWords(num.replace(/,/g, ''));
};

const EnquiryFormModal = ({ showEnquiryModal, closeModal }) => {
    const [customerName, setCustomerName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");
    const [service, setService] = useState("");
    const [notes, setNotes] = useState("");
    const [reminderDate, setReminderDate] = useState("");
    const [reminderTime, setReminderTime] = useState("");
    const [enquirySource, setEnquirySource] = useState("");
    const [customerType, setCustomerType] = useState("new");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [services, setServices] = useState([]);
    const [loanAmount, setLoanAmount] = useState("");
    const [loanType, setLoanType] = useState("")
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const url = process.env.REACT_APP_LINK
   
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${url}/leads/admin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: customerName,
                    mobile: mobile,
                    property_name: businessName,
                    address: address,
                    city: city,
                    pincode: pincode,
                    type: service,
                    remainder_date: reminderDate,
                    remainder_time: reminderTime,
                    type_customer: customerType,
                    remark: notes,
                    email: email,
                    source: enquirySource,
                    assigned_to: isLoggedIn.name,
                    user_id: isLoggedIn.user_id,
                    enquiry_source: loanType,
                    borrowAmount: loanAmount,
                    
                })
            })
            const res = await response.json();
            console.log(res);
            if (response.ok) {
                toast.success("Thank you!", {
                    position: "top-center",
                    autoClose: 3000, // Close toast after 3 seconds
                });
                closeModal();
            } else {
                toast.error(`${res.message}`, {
                    position: "top-center",
                    autoClose: 3000, // Close toast after 3 seconds
                });
            }
        } catch (error) {
            // console.log(error);
            toast.error(`${error}`, {
                position: "top-center",
                autoClose: 10000, // Close toast after 3 seconds
            });
        }
    }

    const [itemsOptions, setItemsOptions] = useState([]);

    const fetchServiceData = async () => {
        try {
            const res = await fetch(`${url}/offerings/all/${isLoggedIn.user_id}`);
            const data = await res.json();
            setItemsOptions(data);
        } catch (error) {
            console.error("Error fetching offerings:", error);
        }
    };





    useEffect(() => {

        fetchServiceData();
    }, [])

    if (!showEnquiryModal) return null;

    return (
        <div className="ls-enquiry-modal">
            <div className="ls-enquiry-modal-content">
                <div className="quotation-header">
                    <h2><i className="fa-solid fa-envelope"></i> New Enquiry</h2>
                    <button className="quotation-close" onClick={closeModal}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="ls-form-group">
                        <label>Customer/Business Owner Name</label>
                        <input type="text" name="customerName" placeholder="Enter full name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
                    </div>
                    <div className="ls-form-group">
                        <label>Mobile Number*</label>
                        <input
                            type="text"
                            name="mobile"
                            placeholder="Enter mobile number"
                            value={mobile}
                            onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(/\D/g, '');
                                if (value.length <= 10) {
                                    if (value === '' || /^[6-9]/.test(value)) {
                                        setMobile(value);
                                    }
                                }
                            }}
                            required
                        />
                        {mobile.length > 0 && mobile.length < 10 && (
                            <p style={{ color: "red", fontSize: "12px" }}>
                                Mobile number must be 10 digits
                            </p>
                        )}
                    </div>


                    <div className="ls-form-group">
                        <label>Email</label>
                        <input type="email" name="email" placeholder="Enter email address" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="ls-form-group">
                        <label>Business Name/Company Name</label>
                        <input type="text" name="businessName" placeholder="Enter business name/ Company Name" value={businessName} onChange={(e) => setBusinessName(e.target.value)} />
                    </div>

                    <div className="ls-form-group">
                        <label>Address</label>
                        <input type="text" name="address" placeholder="Enter address" value={address} onChange={(e) => setAddress(e.target.value)} />
                    </div>

                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>City</label>
                            <input type="text" name="city" placeholder="Enter city" value={city} onChange={(e) => setCity(e.target.value)} />
                        </div>

                        <div className="ls-form-group">
                            <label>Pincode</label>
                            <input
                                type="text"
                                name="pincode"
                                placeholder="Enter pincode"
                                value={pincode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,6}$/.test(value)) { // ✅ Only allows numbers (0-6 digits)
                                        setPincode(value);
                                    }
                                }}

                            />

                        </div>

                    </div>

                    <div className="ls-form-group">
                        <label>Loan Type</label>
                        <select className="ls-categoryservice" name="loanType" id="loanType" value={loanType} onChange={(e) => setLoanType(e.target.value)}>
                            <option value="">Select Loan Type</option>
                            {
                                itemsOptions.map((service, index) => (
                                    <option key={index} value={service.sports_offered}>{service.sports_offered}</option>
                                ))}
                        </select>

                    </div>
                    <div className="ls-form-group">
                        <label>Loan Amount</label>
                        <input
                            type="text"
                            name="loanAmount"
                            placeholder="Enter Loan Amount"
                            value={loanAmount}
                            onChange={(e) => {
                                const raw = e.target.value.replace(/,/g, '').replace(/\D/g, '');
                                const formatted = formatIndianCurrency(raw);
                                setLoanAmount(formatted);
                            }}
                        />
                        {loanAmount && (
                            <p style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>
                                <strong>{numberToWords(loanAmount)}</strong>
                            </p>
                        )}
                    </div>

                    <div className="ls-form-group">
                        <label>Add Note</label>
                        <textarea name="notes" placeholder="Additional notes..." value={notes} onChange={(e) => setNotes(e.target.value)}></textarea>
                    </div>

                    {/* <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>Reminder Date</label>
                            <input type="date" name="reminderDate" value={reminderDate} onChange={(e) => setReminderDate(e.target.value)} />
                        </div>

                        <div className="ls-form-group">
                            <label>Reminder Time</label>
                            <input type="time" name="reminderTime" value={reminderTime} onChange={(e) => setReminderTime(e.target.value)} />
                        </div>
                    </div> */}

                    <div className="ls-form-group">
                        <label>Enquiry Source</label>
                        <input type="text" name="enquirySource" placeholder="Where did you hear about us?" value={enquirySource} onChange={(e) => setEnquirySource(e.target.value)} />
                    </div>

                    <div className="ls-form-group">
                        <label>Type of Customer</label>
                        <div className="ls-radio-group">
                            <label className={`ls-radio-option ${customerType === "Business" ? "selected" : ""}`} onClick={() => setCustomerType("Business")}>
                                <input type="radio" name="customerType" value="Business" checked={customerType === "new"} readOnly /> Business
                            </label>
                            <label className={`ls-radio-option ${customerType === "Salaried" ? "selected" : ""}`} onClick={() => setCustomerType("Salaried")}>
                                <input type="radio" name="customerType" value="Salaried" checked={customerType === "Salaried"} readOnly /> Salaried
                            </label>
                        </div>
                    </div>





                    <div className="ls-modal-action">
                        <button className="ls-modal-cancel" onClick={closeModal}>Cancel</button>
                        <button className="ls-apply-btn">Submit</button>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
};

export default EnquiryFormModal;
